<template>
    <div class="mt-4 lg:px-4">
        <UiComponentHTML :description="description" />
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
    description: String,
});
</script>

<style></style>
